import { UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Flex, Typography, Upload, theme } from "antd";
import { useEffect, useState } from "react";
import { FiUpload } from "react-icons/fi";
import { deepCopy } from "../../utils/deepCopy";
const { Text, Title, Link } = Typography;
const { useToken } = theme;

export function AccountSetupAvatar({
  steps,
  currentStep,
  setCurrentStep,

  metadata,
  setMetadata,
}: {
  steps: number;
  currentStep: number;
  setCurrentStep: (data: number) => void;

  metadata: { [key: string]: any };
  setMetadata: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
}) {
  const { token } = useToken();
  const [avatarBase64, setAvatarBase64] = useState<string>();

  useEffect(() => {
    const avatar = metadata.avatar as string;

    if (avatar) {
      setAvatarBase64(avatar);
    }
  }, [metadata]);

  return (
    <Flex style={{ flexDirection: "column", alignItems: "center" }}>
      <Avatar size={136} src={avatarBase64} icon={<UserOutlined />} />

      <Upload
        multiple={false}
        maxCount={0}
        showUploadList={false}
        accept="image/png, image/jpeg, image/jpg, image/webp"
        beforeUpload={(file) => {
          const reader = new FileReader();

          reader.onload = () => {
            setAvatarBase64(reader.result as string);

            setMetadata((prevState) => {
              const copy = deepCopy(prevState);

              copy.avatar = reader.result;

              return copy;
            });
          };

          reader.readAsDataURL(file);
        }}
      >
        <Button icon={<FiUpload />} style={{ margin: token.marginMD }}>
          <Text>Upload avatar</Text>
        </Button>
      </Upload>

      {/* <Text
        style={{
          color: token.colorTextSecondary,
          marginBottom: token.marginMD,
          marginTop: "-10px",
        }}
      >
        madsonline@gmail.com
      </Text> */}

      <Text
        style={{
          fontWeight: token.fontWeightStrong,
          fontSize: token.fontSizeHeading3,
          lineHeight: token.lineHeightHeading3,
          color: token.colorTextHeading,
          marginTop: token.marginMD,
        }}
      >
        Welcome to Zeitfy
      </Text>
      <Text
        style={{
          fontSize: token.fontSize,
          lineHeight: token.lineHeight,
          color: token.colorText,
          maxWidth: "350px",
          textAlign: "center",
        }}
      >
        Your awnsers to the next few questions will help us to find the right
        content for you.
      </Text>

      <Button
        style={{
          margin: token.marginMD,
          padding: token.paddingContentVerticalLG,
          width: "320px",
          marginTop: token.marginXXL + token.marginXL,
        }}
        type="primary"
        onClick={() => {
          setCurrentStep(currentStep + 1);
        }}
      >
        <Text style={{ color: token.Button?.primaryColor }}>Next</Text>
      </Button>

      <Flex align="center" justify="space-between" style={{ width: "68%" }}>
        {/* <Button
          type="link"
          style={{ padding: 0 }}
          onClick={() => {
            setCurrentStep(currentStep + 1);
          }}
        >
          <Text style={{ textAlign: "left" }}>Skip</Text>
        </Button> */}
        <div />

        <Flex align="center">
          {Array.from({ length: steps }).map((_, index) => {
            if (index > currentStep) {
              return (
                <Button
                  key={index}
                  size="small"
                  style={{
                    background: "transparent",
                    border: "none",
                    boxShadow: "none",
                  }}
                  onClick={() => setCurrentStep(index)}
                >
                  <div
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: token.colorBgContainer,
                      border: `1px solid ${token.colorSplit}`,
                    }}
                  />
                </Button>
              );
            }

            return (
              <Button
                key={index}
                size="small"
                style={{
                  background: "transparent",
                  border: "none",
                  boxShadow: "none",
                }}
                onClick={() => setCurrentStep(index)}
              >
                <div
                  style={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "50%",
                    backgroundColor: token.colorPrimary,
                  }}
                />
              </Button>
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
}
